// Sections that aren't built yet. They say so plainly. No mock data, no controls that look live.
const PLANS: Record<string, { stage: number; what: string[]; needs: string[] }> = {
  "/partnerships": {
    stage: 2,
    what: [
      "Businesses, influencers, partners and affiliates, from outreach to completion",
      "Contacts, owner, agreements, deliverables, content requirements, expenses, referral codes and results",
      "Deliverables linked to tasks, content, calendar dates and budget lines",
      "Affiliate commission terms, attributed conversions, adjustments and payouts, with estimates kept apart from verified amounts",
      "Zomee, Tiny Trials and Radiant Mobile start as unconfirmed until Kayla confirms each one",
    ],
    needs: ["What's signed with Zomee, Tiny Trials and Radiant Mobile, and where the agreements live", "The attribution source for paid conversions (see Decisions)"],
  },
  "/product": {
    stage: 2,
    what: [
      "Roadmap tied to releases: requests, bugs, owners, dependencies, estimates and target dates",
      "iOS and Android readiness tracked separately; a target date is never shown as a verified live date",
      "Links to designs, GitHub issues and PRs, builds, test results and release notes",
      "Review completed work with screenshots or recordings, request fixes, and approve",
      "When a release date moves, linked campaigns, partner commitments and spend are flagged for review, never moved silently",
    ],
    needs: ["Read access to momeaze/momeaze-app issues (GitHub) for links", "Who signs off a release besides Kayla"],
  },
  "/finance": {
    stage: 2,
    what: [
      "Import of the Momeaze Budget Model artifact, keeping its scenarios, drivers, categories and months",
      "A reconciliation report comparing imported totals with the original, with any differences flagged",
      "Planned, committed and actual spending, recurring expenses, vendor payments and revenue",
      "Expenses linked to campaigns, partnerships and development work",
    ],
    needs: [
      "Confirm the Momeaze Budget Model (updated Oct 27) is the source of truth, not the Budget Planner or Budget & Runway",
      "Actuals source: Brex (already read by the budget model) and how App Store and Play payouts are verified",
    ],
  },
  "/calendar": {
    stage: 3,
    what: [
      "One view of meetings, tasks, content, campaigns, partner commitments and releases, filtered by person, team and type",
      "Each person chooses what to share. Private events show as busy only, never their details",
      "Read-only or two-way per provider, with time zones, repeats, changes, cancellations and duplicates handled",
      "Connection health and last sync shown for each calendar",
    ],
    needs: ["Google Workspace confirmed (Nov 3). Next: a Google Cloud OAuth app owned by Momeaze, and each person connecting their own calendar"],
  },
  "/resources": {
    stage: 3,
    what: ["Searchable brand assets, documents, agreements and templates", "Access follows the same permissions as everything else"],
    needs: ["Where brand files live today (Google Drive, Canva, Figma)"],
  },
};

export function NotBuilt({ path }: { path: string }) {
  const p = PLANS[path];
  if (!p) return null;
  return (
    <div className="page">
      <div className="banner info">
        <strong>Not built yet. Planned for Stage {p.stage}.</strong>
      </div>
      <div className="grid">
        <section className="card">
          <h2>What this section will do</h2>
          <ul className="small" style={{ margin: "10px 0 0", paddingLeft: 18, display: "grid", gap: 6 }}>
            {p.what.map((w) => (
              <li key={w}>{w}</li>
            ))}
          </ul>
        </section>
        <section className="card">
          <h2>What it needs first</h2>
          <ul className="small" style={{ margin: "10px 0 0", paddingLeft: 18, display: "grid", gap: 6 }}>
            {p.needs.map((w) => (
              <li key={w}>{w}</li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
